import {
    BRANCH_LIST_REQUEST,
    BRANCH_LIST_SUCCESS,
    BRANCH_LIST_FAIL
} from '../constants/branchConstants'
import api from '../core/api';

export const listBranch = () => async (dispatch, getState) => {
    try {
        dispatch({ type: BRANCH_LIST_REQUEST })

        const { data } = await api.get(
            `/branch`
        )

        var dt = data.Result

        if(typeof(dt)=='string'){
            dispatch({
                type: BRANCH_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: BRANCH_LIST_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: BRANCH_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}